"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadowRaiseMedium = exports.shadowRaiseSubtle = exports.shadowElevateStrong = exports.shadowElevateMedium = exports.shadowElevateSubtle = void 0;
exports.shadowElevateSubtle = "0 8px 12px -4px rgba(0, 0, 0, 0.05)";
exports.shadowElevateMedium = "0 8px 12px -4px rgba(0, 0, 0, 0.1)";
exports.shadowElevateStrong = "0 2px 8px -6px rgba(0, 0, 0, 0.6)";
exports.shadowRaiseSubtle = "0 3px 12px 0 rgba(0, 0, 0, 0.1)";
exports.shadowRaiseMedium = "0 6px 24px 0 rgba(0, 0, 0, 0.1)";